/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import 'react-step-progress-bar/styles.css';
import { ProgressBar, Step } from 'react-step-progress-bar';

export default function OrderLevelProgress({ OrderDetails, prod }) {
    const getPercentage = () => {
        const orderData=OrderDetails
        let orderProduct = null
        if (OrderDetails?.order_info !== undefined && OrderDetails?.order_info !== null){
            let orderProduct1 = orderData.order_info.filter((curr)=> parseInt(curr.INVENTORY_ITEM_ID) === parseInt(prod.INVENTORY_ITEM_ID))
            if (orderProduct1.length > 0) orderProduct = orderProduct1[0]
        }
        
        let total = 0;
        if (orderData.status == '1')
            total=0
        else if (orderData.status == '3'){
            if (orderProduct !== null && orderProduct !== undefined && orderProduct.PENDING_QTY === 0 && orderProduct.CANCELLED_QTY === 0 )
                total=110
            else total = 35
        }
        else if (orderData.status == '4'){
            total=110}
        else if (orderData.status == '5')
            total=85
        else if (orderData.status == '6')
            total=110

        return total;
    };
    return (
        <>
            <ProgressBar
                percent={getPercentage()}
                filledBackground="#206C00"
            >
                <Step transition="scale">
                    {({ accomplished }) => (
                        <img
                            // style={{ filter: `grayscale(${accomplished ? 0 : 100}%)` }}
                            width="5"
                            className="min-w-[20px] min-h-[22px] z-10"
                            src='/images/green.svg'
                        />
                    )}
                </Step>
                <Step transition="scale">
                    {({ accomplished }) => (
                        <img
                            // style={{ filter: `grayscale(${accomplished ? 0 : 100}%)` }}
                            width="5"
                            className="min-w-[20px] min-h-[22px] z-10"
                            src='/images/green.svg'
                        />
                    )}
                </Step>
                <Step transition="scale">
                    {({ accomplished }) => (
                        <img
                            // style={{ filter: `grayscale(${accomplished ? 0 : 100}%)` }}
                            width="5"
                            className="min-w-[20px] min-h-[22px] z-10"
                            src='/images/green.svg'
                        />
                    )}
                </Step>
                <Step transition="scale">
                    {({ accomplished }) => (
                        <img
                            // style={{ filter: `grayscale(${accomplished ? 0 : 100}%)` }}
                            width="5"
                            className="min-w-[20px] min-h-[22px] z-10"
                            src='/images/green.svg'
                        />
                    )}
                </Step>
                <Step transition="scale">
                    {({ accomplished }) => (
                        <img
                            // style={{ filter: `grayscale(${accomplished ? 0 : 100}%)` }}
                            width="5"
                            className="min-w-[20px] min-h-[22px] z-10"
                            src='/images/green.svg'
                        />
                    )}
                </Step>
            </ProgressBar>
            
        </>
    );
}
